import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const railDataMarketplace = defineConnector({
  identifier: "railDataMarketplace",
  name: "Rail Data Marketplace",
  tagLine: "UK rail departures, arrivals, and disruption",
  keywords: "national rail darwin ldbws openldbws rdg knowledgebase train",
  logo,
  protocol: "http",
  tags: ["data", "travel"],
  defaultUrlPattern: () => domainToRegex("api1.raildata.org.uk"),
  auth: (app) => headerAuth([{ name: "x-apikey", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Subscribe to a data product",
      items: [
        {
          kind: "markdown",
          content:
            "Register at the [**Rail Data Marketplace**](https://raildata.org.uk/), find the product you need in the catalog, and request a subscription. The data owner approves each subscription, which can take a few days. Once approved, open **My Dashboard > My subscriptions** to reveal its consumer key.",
        },
      ],
    },
    {
      title: "Copy and paste the consumer key into the field below",
      items: [
        {
          kind: "input",
          label: "Consumer key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          helperText:
            "Each approved subscription has its own consumer key, so use the one for the product you plan to call.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api1.raildata.org.uk/1010-live-departure-board-dep1_2/LDBWS/api/20220120/GetDepBoardWithDetails/KGX",
      expectedStatus: [200, 403],
    }),
  },
});
